module.exports = __webpack_public_path__ + "static/media/fun2.dc53db60.png";